import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { useUserData } from "../service/api/useUserData";
import useSelectedDomain from "../service/Hooks/useSelectedDomain";
import { getEvolutionOrderClient } from "../service/api/Order";

export default function ClientChart({ accountId }) {
    const [data, setData] = useState([]);
    const selectedDomain = useSelectedDomain();
    const [activeIndex, setActiveIndex] = useState(null);

     // gerer l'id de l'utilisateur connecte
      const { getUserInfo } = useUserData();
      const [creatorId, setCreatorId] = useState(null);
  
      useEffect(() => {
          async function fetchUserData() {
              const userInfo = await getUserInfo();
              if (userInfo) {
                  setCreatorId(userInfo.accountId);
              }
          }
          fetchUserData();
      }, []);
      // fin de la gestion de l'id de l'utilisateur connecte
      

    useEffect(() => {
        const fetchData = async () => {
            if (!selectedDomain || !selectedDomain.id || !creatorId) return;
            try {
                const responseData = await getEvolutionOrderClient(creatorId, selectedDomain.id);
                // Transformez les données de l'API en format adapté pour PieChart
                const formattedData = responseData.map(item => ({
                    name: `Mois ${item.month}/${item.year}`, // Utiliser mois et année pour le nom
                    value: item.volume, // Utiliser volume pour la valeur
                    color: getRandomColor() // Fonction pour générer des couleurs aléatoires
                }));
                setData(formattedData);
            } catch (error) {
                console.error("Erreur lors de la récupération des données de commande:", error);
            }
        };
        fetchData();
    }, [selectedDomain, creatorId]);

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const total = data.reduce((acc, item) => acc + item.value, 0);

    const onMouseEnter = (index) => {
        setActiveIndex(index);
    };

    const onMouseLeave = () => {
        setActiveIndex(null);
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { color, name, value } = payload[0].payload;
            return (
                <div
                    className="custom-tooltip"
                    style={{
                        backgroundColor: color,
                        color: "#fff",
                        padding: "5px",
                        borderRadius: "5px",
                    }}
                >
                    <p>{`${name}: ${value} (${((value / total) * 100).toFixed(0)}%)`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <>
            <div className="col-xl-4 wow fadeInUp" data-wow-delay="1s">
                <div className="card">
                    <div className="card-header border-0">
                        <h2 className="card-title">Evolution de mes ordres (par mois)</h2>
                    </div>
                    <div className="card-body text-center pt-0 pb-2">
                        <div className="d-inline-block">
                            <PieChart width={250} height={250}>
                                <Pie
                                    data={data}
                                    cx="60%"
                                    cy="60%"
                                    innerRadius={70}
                                    outerRadius={90}
                                    fill="#8884d8"
                                    paddingAngle={5}
                                    dataKey="value"
                                >
                                    {data.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={
                                                activeIndex === index
                                                    ? `${entry.color}80`
                                                    : entry.color
                                            }
                                            onMouseEnter={() => onMouseEnter(index)}
                                            onMouseLeave={onMouseLeave}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip content={<CustomTooltip />} />
                            </PieChart>
                        </div>
                        <div className="chart-items">
                            <div className="row">
                                <div className="col-xl-12 col-sm-12">
                                    <div className="text-start mt-2">
                                        <h6>Legend</h6>
                                        {data.map((item, index) => (
                                            <div className="color-picker" key={index}>
                                                <p className="mb-0 text-gray">
                                                    <svg
                                                        className="me-2"
                                                        width="14"
                                                        height="14"
                                                        viewBox="0 0 14 14"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <rect width="14" height="14" rx="4" fill={item.color} />
                                                    </svg>
                                                    {item.name} ({((item.value / total) * 100).toFixed(0)}%)
                                                </p>
                                                <h6 className="mb-0">{item.value}</h6>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}